import { render, staticRenderFns } from "./PersEdit.vue?vue&type=template&id=afc7bca4&scoped=true"
import script from "./PersEdit.vue?vue&type=script&lang=js"
export * from "./PersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc7bca4",
  null
  
)

export default component.exports